import { Component, OnInit, inject } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

import { DatasheetFacade } from '@mitsubishi/project/data-access';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-working-condition-wrapper',
  templateUrl: './working-condition-wrapper.component.html',
  styleUrls: ['./working-condition-wrapper.component.scss'],
  standalone: false,
})
export class WorkingConditionWrapperComponent extends FieldWrapper implements OnInit {
  isEditing$ = inject(DatasheetFacade).isEditing$;
  areAllFieldsHidden = false;

  onToggle(event: MatCheckboxChange) {
    if (event.checked) {
      this.form.enable();
    } else {
      this.form.disable();
    }
  }

  ngOnInit(): void {
    if (this.props.isActive === false || this.props.disabled === true) {
      setTimeout(() => {
        this.form.disable();
      }, 0);
    }

    this.areAllFieldsHidden = this.field.fieldGroup
      ? this.field.fieldGroup.every(field => field.props?.hidden === true)
      : true;
  }
}
